import React, { useEffect, useState } from 'react'

import { SmartTooltip } from '../../../../../../../components/SmartTooltip/SmartTooltip'
import { formatMskDateTime, parseServerInstant } from '../../../Dashboard/core/mskTime'
import { formatAutoCancelRemaining, msUntilAutoCancelTextChanges } from '../../core/autoCancel'

interface Props {
  autoCloseAt?: string | null
}

/**
 * Обратный отсчёт до автоотмены спора. Считает сам и перерисовывает только себя: таймер ставится
 * ровно на момент, когда сменится текст, — список при этом не перезапрашивается.
 */
export const DisputeAutoCancelCountdown: React.FC<Props> = ({ autoCloseAt }) => {
  const closeAt = autoCloseAt ? parseServerInstant(autoCloseAt).getTime() : NaN
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    setNow(Date.now())
    if (Number.isNaN(closeAt)) {
      return
    }

    let timer: ReturnType<typeof setTimeout> | undefined
    const schedule = () => {
      const delay = msUntilAutoCancelTextChanges(closeAt - Date.now())
      if (delay === null) {
        return
      }
      timer = setTimeout(() => {
        setNow(Date.now())
        schedule()
      }, delay)
    }
    schedule()

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer)
      }
    }
  }, [closeAt])

  if (Number.isNaN(closeAt)) {
    return <span className='text-muted'>—</span>
  }

  return (
    <SmartTooltip content={<div>{formatMskDateTime(autoCloseAt)} МСК</div>}>
      <span style={{ cursor: 'help' }}>{formatAutoCancelRemaining(closeAt - now)}</span>
    </SmartTooltip>
  )
}
